(function(){
   
  const myInterval = setInterval(function(){
    if(document.readyState === "complete"){
      setTimeout(()=>{
       toggleBwpIconHandler();      
        
      }, 1000);
      clearInterval(myInterval);
    }
  }, 1000);
  
  const toggleBwpIconHandler = () => {
    let bwpBtn = document.querySelector(".bwp-widget-loaded");
    let bwpIcon = document.querySelector(".bwp-icon");
    if(bwpBtn === null){
      bwpIcon.style.display = "none";
    }
    else{
      bwpIcon.style.display = "block";
    }
    
  }
})();